import {
  IAction,
  IBooleanValueAction,
  IStringValueAction
} from "../../../redux/actions";

export enum types {
  TRIGGER_HOME_REQUEST = "TRIGGER_HOME_REQUEST",
  SET_MOBILE_PLUGIN_MENU_BUTTON_ICON = "SET_MOBILE_PLUGIN_MENU_BUTTON_ICON",
  SET_PLUGIN_AVAILABLE = "SET_PLUGIN_AVAILABLE",
  SET_PLUGIN_ENABLED = "SET_PLUGIN_ENABLED",
  SET_HOME_AVAILABLE = "SET_HOME_AVAILABLE",
  SET_HOME_ENABLED = "SET_HOME_ENABLED",
  TRIGGER_PLUGIN_REQUEST = "TRIGGER_PLUGIN_REQUEST"
}

export const triggerHomeRequest = (): IAction => {
  return {
    type: types.TRIGGER_HOME_REQUEST
  };
};

export const triggerPluginRequest = (): IAction => {
  return {
    type: types.TRIGGER_PLUGIN_REQUEST
  };
};

export const setHomeAvailable = (value: boolean): IBooleanValueAction => {
  return {
    type: types.SET_HOME_AVAILABLE,
    value
  };
};

export const setHomeEnabled = (value: boolean): IBooleanValueAction => {
  return {
    type: types.SET_HOME_ENABLED,
    value
  };
};

export const setPluginAvailable = (value: boolean): IBooleanValueAction => {
  return {
    type: types.SET_PLUGIN_AVAILABLE,
    value
  };
};

export const setPluginEnabled = (value: boolean): IBooleanValueAction => {
  return {
    type: types.SET_PLUGIN_ENABLED,
    value
  };
};

export const setMobilePluginMenuButtonIcon = (
  value: string
): IStringValueAction => {
  return {
    type: types.SET_MOBILE_PLUGIN_MENU_BUTTON_ICON,
    value
  };
};
